export interface LatLng {
  lat: number;
  lng: number;
}
export const getDefaultLatLng = (): LatLng => ({ lat: 0.0, lng: 0.0 });
